import {
  IconAdornment,
  type IconAdornmentComponentProps,
} from './IconAdornment';
import { cn } from '@/lib/utils';
import { IMaskInput } from 'react-imask';
import { useRef } from 'react';

interface MaskedInputProps
  extends
    React.InputHTMLAttributes<HTMLInputElement>,
    Omit<IconAdornmentComponentProps, 'children'> {
  mask?: string;
}

export function MaskedInput({
  mask,
  IconPrefix = null,
  IconSuffix = null,
  className = '',
  onIconClick,
  onChange,
  ...props
}: MaskedInputProps) {
  const maskRef = useRef<HTMLInputElement>(null);
  const rawValue = props.value != null ? String(props.value) : '';

  return (
    <IconAdornment
      IconPrefix={IconPrefix}
      IconSuffix={IconSuffix}
      onIconClick={onIconClick}
    >
      <IMaskInput
        className={cn(
          'w-full',
          !props.readOnly &&
            'px-4 py-3 border rounded-lg border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200',
          !props.readOnly && IconPrefix && 'pl-10',
          !props.readOnly && IconSuffix && 'pr-10',
          className
        )}
        {...props}
        mask={mask}
        lazy={true}
        value={rawValue}
        inputRef={maskRef}
        onAccept={(val: string) => {
          const stripped =
            val.length === 11 && val.startsWith('1') ? val.slice(1) : val;

          if (stripped === '' && maskRef.current) {
            maskRef.current.value = '';
          }
          onChange?.({
            target: {
              name: props.name,
              value: stripped,
            },
          } as React.ChangeEvent<HTMLInputElement>);
        }}
        unmask={true}
      />
    </IconAdornment>
  );
}
